import React from 'react';

import { Table, Icon } from 'semantic-ui-react';

import { Tooltip } from '../../../components';
import { formatCurrency } from '../../../utils/valueFormatter';
import { SparkChart } from '../MarketingPerformance/charts';

export const labelStyles = {
  fontSize: 12,
  fontWeight: 500,
  padding: 5,
  marginLeft: 7,
};

export const AddXCell = ({ item, col }) => (
  <Table.Cell style={{ textAlign: 'right' }}>
    <p>
      {`${item[col.key]}${item[col.key] === 'N/A' ? '' : 'X'}`}
    </p>
  </Table.Cell>
);

export const ChannelCell = ({ item, col }) => (
  <Table.Cell style={{ textAlign: 'left' }}>
    {item.expandButton && item.expandButton}
    <div style={{ width: 250 }}>
      {item.color && <Icon name="circle" style={{ color: item.color }} size="large" />}
      <span>
        {item[col.key]}
      </span>
      {item.tooltip && (
        <Tooltip
          icon={item.tooltip.icon}
          content={item.tooltip.content}
          color="purple"
          position="fixed"
          style={{ float: 'right', cursor: 'pointer' }}
          on="click"
        />
      )}
    </div>
  </Table.Cell>
);

export const CPACell = ({ item, col }) => (
  <Table.Cell style={{ textAlign: 'right' }}>
    <p>
      {formatCurrency(item[col.key])}
    </p>
  </Table.Cell>
);

export const CurrencyCell = ({ item, col }) => (
  <Table.Cell style={{ textAlign: 'right' }}>
    <p>{formatCurrency(item[col.key], 'USD', col.decimals || 0)}</p>
  </Table.Cell>
);

export const NumberCell = ({ item, col }) => {
  const value = item[col.key];

  if (Number.isNaN(value) || typeof value !== 'number') {
    return <Table.Cell style={{ textAlign: 'right' }}><p>-</p></Table.Cell>;
  }

  const formatted = value.toLocaleString('en-US', {
    maximumFractionDigits: col.decimals || 0,
  });

  return (
    <Table.Cell style={{ textAlign: 'right' }}>
      <p>{formatted}</p>
    </Table.Cell>
  );
};

export const PercentCell = ({ item, col }) => {
  const { formatter } = col;
  return (
    <Table.Cell style={{ textAlign: 'right' }} content={`${formatter(item[col.key])}%`} />
  );
};

export const SpendEffectCell = ({ item, col }) => (
  <Table.Cell style={{ padding: 1 }}>
    <SparkChart data={[item]} maxVal={col.maxValue} />
  </Table.Cell>
);
